import { SvgConsumer } from '@components/icons/svgConsumer';
import { IssueListItemProps } from './types';
import { useDownloadIssueImage } from '@services/issues/download';
import { cn } from '@utils/cn';
import { useAccess } from '@hooks/access';

export const IssueListItem = ({
  issueId,
  data: { id: imageId, filename, url },
}: IssueListItemProps) => {
  const access = useAccess();
  const download = useDownloadIssueImage();

  return (
    <li className="group flex items-center gap-3 p-1 font-semibold text-primary-500">
      <span className="flex items-center gap-2">
        <SvgConsumer className="shrink-0" id="file" />
        <a
          className="cursor-pointer text-sm hover:underline"
          href={url}
          onClick={(e) => {
            if (url) return;
            e.preventDefault();
            download.mutate({ issueId, imageId });
          }}
          target="_blank"
          rel="noopener noreferrer">
          {filename}
        </a>
      </span>
      <button
        type="button"
        onClick={() => download.mutate({ issueId, imageId })}
        className={cn([
          'p-1 text-m text-neutral-300 hover:text-blue-400',
          !access.fieldUser && 'opacity-0 group-hover:opacity-100',
        ])}>
        <SvgConsumer id="downloadDocument" />
      </button>
    </li>
  );
};
